import Script from "next/script";
import styles from "./KlarnaPaymentMessage.module.scss";
import { RuntimeConfig } from "@/types/types.ts";

type Props = {
  currentPrice?: string;
  runtimeConfig: RuntimeConfig;
  /**
   * Apply premium typography variant (useNewTypography flag):
   * - osm-cta ("learn more" link): underline button style at 14px
   * - osm-legal (T&Cs text): small text body premium at 12px
   */
  useNewTypography?: boolean;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace React.JSX {
    export interface IntrinsicElements {
      "klarna-placement": {
        id: string;
        "data-key": string;
        "data-locale": string;
        "data-purchase-amount"?: string;
      };
    }
  }
}

export const KlarnaPaymentMessageUI = ({
  currentPrice,
  runtimeConfig,
  useNewTypography = false,
}: Props) => {
  return (
    <>
      <Script
        async
        data-environment={runtimeConfig?.klarnaEnvironment}
        src={runtimeConfig?.klarnaScriptURL}
        data-client-id={runtimeConfig?.klarnaClientId}
      />
      <style>
        {`
          #klarnaPlacementMessage::part(osm-container){
            padding-left: 0;
            padding-right: 0;
          }

          #klarnaPlacementMessage::part(osm-container),
          #klarnaPlacementMessage::part(osm-cta){
            font-family: GillSansforJL, Gill Sans, Gill Sans MT, GillSansMTStd-Medium, Avenir, Corbel, Arial, Helvetica, sans-serif;
            color: #141414;
          }

          #klarnaPlacementMessage::part(osm-legal) {
            color: #6F6F6F;
            text-align: left;
          }
          ${
            useNewTypography
              ? `
          #klarnaPlacementMessage::part(osm-cta) {
            font-size: 14px;
            text-decoration: underline;
            text-underline-offset: 2px;
          }

          #klarnaPlacementMessage::part(osm-legal) {
            font-size: 12px;
          }
          `
              : ""
          }
        `}
      </style>
      <div
        className={styles.klarnaPaymentMessage__block}
        data-component="KlarnaPaymentMessage"
        data-testid="klarna-payment-message-container"
      >
        <klarna-placement
          id="klarnaPlacementMessage"
          data-key="credit-promotion-auto-size"
          data-locale="en-GB"
          data-purchase-amount={currentPrice}
        />
      </div>
    </>
  );
};
